import {di} from "@dp-instant/core";
import {Random} from "@dp-instant/utils";
import {color} from "@game/coregame/helpers";
import {IBuilding} from "@game/coregame/interfaces/IBuilding";
import {PlayerType} from "@game/coregame/interfaces/PlayerType";
import {gsap} from "gsap/gsap-core";
import {Container, Sprite} from "pixi.js-legacy";
import {Population} from "./Population";
import {TypesGame} from "@game/TypesGame";
import {GenerateMapShapeAction} from "@game/coregame/actions/GenerateMapShapeAction";
import {inject, injectable} from "inversify";
import {SkinManager} from "../managers/SkinManager";

@injectable()
export class StateShapeView extends Container {
    private _shapesSprite?: Sprite;
    private _container: Container = new Container();
    private _color = 0x000000;
    private _baseColorMin = 0x00ff00;
    private _baseColorMax = 0xff0000;
    private _fill = 1;
    private _initialPromise = Promise.resolve();

    @inject(TypesGame.skinManager)
    private skinManager: SkinManager;

    get initialPromise() {
        return this._initialPromise;
    }

    async init(data: IBuilding, name: string = Random.UUID()) {
        this.addChild(this._container);
        this._initialPromise = (async () => {
            this._shapesSprite = await di
                .get<GenerateMapShapeAction>(TypesGame.actions.createMapPart)
                .run({id: `field-${name}`, shapes: data.shapes || []});
            this._shapesSprite.tint = this._color;
            this._container.addChild(this._shapesSprite);
        })();
    }

    public updateSkin(owner: PlayerType) {
        //const [fillColor] = GameColors.players[owner];
        const [fillColor] = this.skinManager.getColorBy(owner);
        this._baseColorMax = color.fromHex(fillColor);
        this._baseColorMin = color.lerp(0xffffff, this._baseColorMax, 0.4);
        this.updateFill();
    }

    public updateWithPopulation(population: Population, animate = false) {
        if (gsap.isTweening(this)) {
            gsap.killTweensOf(this, "fill");
        }
        if (animate) {
            gsap.to(this, {fill: Math.min(1, population.current / population.cap)});
        } else {
            this._fill = Math.min(1, population.current / population.cap);
            this.updateFill();
        }
    }
    private get fill(): number {
        return this._fill;
    }
    private set fill(value: number) {
        this._fill = value;
        this.updateFill();
    }
    private updateFill() {
        this.color = color.lerp(this._baseColorMin, this._baseColorMax, this._fill);
    }

    private set color(value: number) {
        this._color = value;
        if (this._shapesSprite) {
            this._shapesSprite.tint = this._color;
        }
    }
    get baseColorMax(): number {
        return this._baseColorMax;
    }
    private _active = true;

    setActive(value: bool, duration?: number) {
        this._active = value;
        gsap.killTweensOf(this, "alpha");
        gsap.to(this, {alpha: this._active ? 1 : 0.25, duration});
    }
}
